
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DataStatisticsAPI from "@/common/api/dataStatistics";
import { getPageAPIs } from "@/common/util";
export const pageApiList = getPageAPIs(DataStatisticsAPI);
@Component
export default class DataStatistics extends Vue {
  private DataStatisticsAPI: any = new DataStatisticsAPI();
  private activated(): void {
    this.getData()
  }
  private result:any = {}
  private type:number = 1
  private typeArray:any[] = [
    {label:'今天',value:1},
    {label:'昨天',value:2},
    {label:'近7天',value:3},
    {label:'本月',value:4},
    {label:'上月',value:5}
  ]
  private getData(): void {
    this.DataStatisticsAPI.getStatBusiness(
        {type:this.type},
        (res: any) => {
          console.log('营业额',res)
          this.result = res.data.item
        }
    );
  }
  private changeSelect():void{
    this.getData()
  }
}
